import React, { useState, forwardRef } from "react";
import {
    Button,
    Stack,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle
} from "@mui/material";

const defaultConfirmText = "Are you sure you want to delete the selected item(s)? This action cannot be undone.";
const defaultTitle = "Confirm Deletion";

const ConfirmDelete = forwardRef(({ onConfirm, children, confirmText = defaultConfirmText, dialogTitle = defaultTitle, ...props }, ref) => {
    const [open, setOpen] = useState(false);

    const handleClick = (e) => {
        e?.stopPropagation?.();
        setOpen(true);
    };
    const handleClose = () => setOpen(false);
    const handleConfirm = () => {
        onConfirm?.();
        setOpen(false);
    };

    return (
        <>
            <Stack {...props} ref={ref} onClick={handleClick}>
                {children}
            </Stack>

            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{dialogTitle}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {confirmText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>Cancel</Button>
                    <Button onClick={handleConfirm} color="error" variant="contained">
                        Confirm
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
});

export default ConfirmDelete;
